import { REMOVE_DEVICES, SET_DEVICE_DATA, SET_TOTAL_DEVICES, SET_DEVICE_CURRENT_PAGE, SET_DEVICE_PAGE_SIZE } from "../types";

export const setDevicesData = (data) => ({
    type: SET_DEVICE_DATA,
    payload: data,
})

export const setTotalDevices = (totalDevices) => ({
    type: SET_TOTAL_DEVICES,
    payload: totalDevices,
});

export const setCurrentPage = (page) => ({
    type: SET_DEVICE_CURRENT_PAGE,
    payload: page,
});

export const setPageSize = (size) => ({
    type: SET_DEVICE_PAGE_SIZE,
    payload: size,
});

export const removeDevices = () => {
    return {
        type: REMOVE_DEVICES
    }
}